import { Module } from 'vuex';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { CartState } from './types';
import { RootState } from '../types';

export const state: CartState = {
  customer: {
    gender: 'MALE',
    address: {},
  },
  invoice: {
    address: {},
    type: 'INDIVIDUAL',
  },
  products: [],
  promotionCode: '',
  total: { value: 0, currency: '' },
  isLoading: true,
};

const namespaced = true;

export const cart: Module<CartState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
